import axiosInstance from "./AxiosConfig";

class TransactionApi {
  async CreateTransaction(data) {
    try {
      const response = await axiosInstance.post("/transaction1/create", data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetTransaction(fromDate, toDate) {
    try {
      const response = await axiosInstance.get(`/transaction1/getTransaction?fromDate=${fromDate}&toDate=${toDate}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetTransactionByBranch(branchHash, fromDate, toDate) {
    try {
      const response = await axiosInstance.get(`/transaction1/getTransaction?hashValue=${branchHash}&fromDate=${fromDate}&toDate=${toDate}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateTransaction(id, data) {
    try {
      const response = await axiosInstance.put(
        `/transaction1/update/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteTransaction(id) {
    try {
      const response = await axiosInstance.delete(`/transaction1/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new TransactionApi();
